export default {
  lang: 'Zh',
  slogan:'全双工卫星通信：光缕双生，星地同吟',
  home: "首页",
  news: "新闻动态",
  verification: "实验验证",
  full_duplex: "全双工通信",
  research: "科研进展",
  about: "关于我们",
  standards: "标准制定",
  lectures: "讲座公告",
  linkUs: "联系我们",
  medical:"医疗物联网",
  address: "地址: 北京大学理科二号楼2450",
  phone: "联系电话: 010-62753003",
  shiyanshi: "北京大学时空道宇先进通信联合实验室",
  copyright: "版权所有@北京大学",
  links_title: "相关链接",
  school: "北京大学电子学院",
  tech: "时空道宇科技",
  inside_pages: "内页",
  find_more:"了解更多",
  news_center:"新闻中心",
  home_lab_title: "北京大学时空道宇先进通信实验室",
  home_lab_des1: "本实验室致力于全双工卫星通信理论与关键技术研究，是国际上最早系统开展星地全双工通信研究的学术机构之一。实验室规划构建全球全双工卫星通信验证网络，通过创新性的信号处理与组网技术实现高效部署，已完成星地全双工实时通信关键技术验证，未来将推动6G卫星通信、星上智能处理、空天地协同网络等前沿方向的发展，满足未来通信、应急救灾、海洋监测、物联网等多样化应用需求。",
  home_lab_des2: "实验室依托北京大学电子学院的科研优势，与时空道宇开展深度合作，致力于卫星通信关键技术攻关与理论创新，为我国卫星通信技术的发展提供学术支撑。",
  home_directions:"研究方向",
  home_directions1:{
    title:"全双工通信低轨卫星研制",
    details1:"星载全双工通信载荷设计与实现",
    details2:"适用于空间环境的全双工收发系统开发",
    details3:"卫星平台与通信载荷一体化集成技术",
    details4:"星载设备在轨测试及可靠性保障技术",
  },
  home_directions2:{
    title:"卫星通信系统产业化关键技术",
    details1:"全双工卫星通信地面终端研制",
    details2:"星地协同通信网络架构设计",
    details3:"产业化应用场景验证与优化",
    details4:"通信系统性能测试与评估体系建立",
  },
  home_directions3:{
    title:"全双工卫星通信标准研究",
    details1:"全双工卫星通信协议设计与优化",
    details2:"星地接口互操作性研究",
    details3:"系统兼容性与互操作性研究",
    details4:"参与国际国内相关标准制定工作",
  },
  home_directions4:{
    title:"6G通信基础理论研究",
    details1:"面向6G的星地融合网络架构",
    details2:"全双工通信基础理论与算法创新",
    details3:"空天地一体化频谱资源方法",
    details4:"新型星地接入与干扰管理技术",
  },
  current_leadership:"现任领导",
  leader1: {
    name: '焦秉立',
    position: '北京大学 - 时空道宇先进通信联合实验室主任',
    des:"北京大学电子学院教授；北京大学全球健康发展学院教授（双聘）；移动数字医疗教育部工程技术研究中心主任；中国工业信息化部科技委常委；中国通信学会智慧医疗专家委员会常务副主任；VTS Beijing Chapter Chair;普林斯顿客座研究人员；1995年毕业于德国University of Saarland,到目前为止，在期刊和会议上发表了二百余篇论文，30多项授权发明专利。以负责人身份承担过和正在承担多个国家自然科学基金（包括：重点和国际交流项目）、重大专项及和国内外合作项目。",
  },
  leader2: {
    name: '王洋',
    position: '北京大学 - 时空道宇先进通信联合实验室副主任',
    des:"博士，浙江时空道宇科技有限公司创始人、\nCEO、首席系统工程专家；青岛上合航天科技有限公司董事长；涟漪位置（广州）科技有限公司董事长；台州星空智联科技有限公司董事长。曾供职于华为、中科院微小卫星创新研究院。曾任两家以上国有航天卫星研制与研发企业总经理，常务副总经理职务，具备多年的国家卫星工程项目经验，以及丰富扎实的国有航天企业管理经验。历时4年主导研制“嘉定一号”物联通信卫星，并于2018年成功发射，开启中国首个物联通信星座布局。2018年，获吉利战略投资创办时空道宇。",
  },
  about_lab_des:"北京大学时空道宇先进通信联合实验室由北京大学电子学院与浙江时空道宇科技有限公司于2023年9月成立，旨在推动无线全双工通信技术在卫星通信领域的创新突破。实验室依托北京大学在无线通信领域的深厚学术积淀，结合时空道宇在卫星系统研制方面的工程优势，共同开展前沿通信技术研究。",
  about_viewpoints:"教授观点",
  core_achievements:"核心成果",
  core_title:"北京大学2006年全球首创同频同时全双工通信技术",
  core_p1:"2006年9月，北京大学提交发明专利“一种适用于同频同时隙双工的干扰消除方法”，并于2010年获得授权。专利所描述的基站系统模型将发射信号和接收信号设置在同一频点和同一时间上，实现两个独立数据流双向通信的构想，并提供自干扰消除方法。该发明提交时间早于国外，并在2009年国家重大专项实施和推动下迅速形成了国内研究热点。由于本发明的影响，我们避免了这项新技术由国外开启，国内跟进的局面。",
  core_p2:"迄今为止，团队已申请相关发明专利50余项，授权20余项，团队技术先进性始终处于世界领先地位。",
  honor:"荣誉奖项",
  honor_title:"北京大学焦秉立教授团队荣获中国通信学会科学技术一等奖",
  honor_p1:'中国通信学会2020年度科学技术奖评选结果揭晓，由北京大学焦秉立教授领衔，联合中兴通讯股份有限公司、西安空间无线电技术研究所共同完成的"同频同时全双工技术发明"项目荣获技术发明类一等奖。',
  honor_p2:'该项目基于焦秉立教授团队2006年提出的原创性专利技术，在无线通信领域取得重要突破，通过创新方法显著提升了频谱利用效率，为未来通信系统的发展提供了新的技术路径。团队的研究成果不仅在国际学术界获得广泛认可，还成功实现产业化应用，在中兴通讯等企业的产品中落地，创造了显著的经济效益。',
  honor_p3:'焦秉立教授作为项目负责人，长期致力于通信技术研究，其团队在基础理论和工程实践方面均取得重要进展。此次获奖体现了北京大学在信息科学技术领域的创新实力，也为我国通信产业的自主发展作出了重要贡献。',
  honor_p4:'中国通信学会科学技术奖是国内通信领域的权威奖项，旨在表彰在科学研究、技术发明和产业化应用中取得突出成就的团队与个人。',
  //实验验证
  verification_title: "为进一步评估全双工通信载荷收发机的实际通信性能，进行了5次外场实测验证，分别包括动态飞行场景和远距离静态点对点通信。",
  verification1: {
    title:"(1) 旋翼无人机和远程测试外出测试（硬判误码率在0.1%）",
    description:"为模拟空-地通信环境，于2023年1月，在北京市昌平区利用小型四旋翼无人机进行了100m低空测试并成功实现全双工通信。该实验成功验证了所研制的通信样机原型系统在飞行器抖动、风力等因素影响下的鲁棒性。",
  },
  verification2: {
    title:"(2) 6.2km地面测试",
    description:"为了探索CCFD在卫星通信系统中应用的可能性，于2023年4月在河北省保定市定兴县进行了实验。这个点对点通信测试系统，其载波频率为5.8GHz，带宽为20MHz，通信距离为6.2公里。图1地图右上方表示了一个通信节点，它用于模拟星载设备，所使用的两个天线为图2所示的两个阵列，一个用于信号发射，另一个用于信号接收。",
    imgtext:"图1  点对点CCFD通信场景卫星图，通信距离为6.2公里",
    des:"地图左下方设置的另一个通信节点用于模拟地面接收站，它采用两个相同的增益为22dB抛物面天线。图1和图2分别表示信号发射天线和接收天线，模拟地面接收站的两个天线之间的距离为45米。经实际测试，这两个天线的自干扰隔离效果如下：其CCFD发射信号机对接收机的自干扰可以忽略不计。",
    imgtext1:"图1  模拟的星载CCFD天线阵列",
    imgtext2:"图2  模拟地面站的接收天线",
  },
  verification3: {
    title:"(3) 500m固定翼无人机测试",
    description:"为模拟卫星过境场景，于2023年6月，在黑龙江省哈尔滨市呼兰区采用固定翼无人机进行低空500m飞行测试，无人机水平飞行速度为20m/s，在空旷场地布置地面样机，收发天线距离20米，试验环境如何所示。测试结果表明，总隔离能力达到113dB。",
    imgtext:"图4  500m固定翼无人机测试",
  },
  verification4: {
    title:"(4) 4.6km高空热气球测试",
    description:"为模拟卫星掠射场景，于2023年9月，在山西省太原市清徐县利用热气球实现了4.6km的高空试验，试验环境如图4所示，通信时对应的仰角为11°，通信距离为4580m。热气球水平飞行速度与风速相同，当时试验环境下为5m/s，挂飞设备安装入热气球吊舱，在空旷场地布置地面样机，收发天线距离20米。系统总隔离能力达到120dB。",
    imgtext:"图5  4.6km高空热气球测试",
  },
  verification5: {
    title:"(5) 20km地面测试",
    description:"于2025年1月，完成了地面20km点对点全双工通信测试，信号传输的理论空间衰减为134dB。系统工作频率为5.8GHz。经泰尔实验室认证，试验卫星节点自干扰消除能力为123.1dB。",
  },
  verlist:[1,2],
  time:"时间",
  enterprise_news :"所属：企业动态",
  related_news:"相关新闻",
  news1: {
    time:"2024.04.14",
    title:'第一届新一代空天通信技术及产业发展研讨会暨一带一路医疗物联网应用研讨会在京成功举办',
    des1:'2024年4月13日，由北京大学-时空道宇先进通信联合实验室主办的第一届“新一代空天通信技术及产业发展研讨会暨一带一路医疗物联网应用研讨会”在北京怀柔举行。本次会议聚焦空天通信技术与医疗物联网的前沿发展，吸引了近百位来自政府、高校、科研机构及企业的专家学者参与。\n会议开幕式由北京大学电子学院焦秉立教授主持。作为国内空天通信领域的权威专家，焦秉立教授在致辞中强调了同频同时全双工（CCFD）技术在卫星通信中的突破性意义，并指出其在提升频谱效率、推动低轨卫星通信发展方面的巨大潜力。',
    img1:'北京大学焦秉立教授主持会议',
    des2:'中国通信标准化协会闻库理事长在致辞中表示，空天通信是国家战略科技力量的重要组成部分，未来需加强产学研协同创新，加速技术成果转化，助力我国在全球空间和频率资源竞争中占据领先地位。',
    img2:'中国通信标准化协会闻库理事长致辞',
    des3:'浙江时空道宇科技有限公司工程系统副总指挥漆庄平在会上分享了公司在低轨卫星星座设计等方面的最新进展，并探讨了卫星互联网在手机直连领域的应用前景。',
    img3:'浙江时空道宇科技有限公司漆庄平副总指挥（工程系统）作现场报告',
    lastDes:'本次会议围绕六大核心议题展开深入讨论，涵盖火箭发射流程和规范、卫星设计、星载设备卫星通信技术要求、地面接收站技术、低空无人机通信、阵列天线技术等。此外，与会专家还围绕卫星通信、空中和地面一体化的信息交互，遥测遥感、目标监控及数据分析，星载高算力支持的边远地区医疗物联网信息服务的产业应用等方面进行了深入讨论。\n大会设有1个主会场和1个分会场，为通信领域的专家学者，工程技术人员、研发人员和企业提供了一个交流前沿技术和推动学术成果产业化合作的共享平台。会议共收到10个邀请报告，其中包括：北京大学电子学院魏贤龙副院长，中国空间技术研究院朱舸主任，北京星河动力航天科技股份有限公司皇甫素伟副部长（军工业务部）应邀出席。此外，来自中国科学院国家天文台、中信科移动通信技术股份有限公司、中国卫通集团股份有限公司等单位的专家学者也参与了会议研讨，共同就空天通信技术发展建言献策。'
  },
  news2: {
    time:"2023.09.15",
    title:"北京大学—时空道宇先进通信联合实验室正式成立",
    des1:'9月14日，“北京大学—时空道宇先进通信联合实验室”（以下简称“联合实验室”）签约仪式在北京大学英杰交流中心举行。中国通信标准化协会闻库理事长，浙江吉利控股集团魏志玲高级副总裁，浙江时空道宇科技有限公司王洋CEO，北京大学全球健康发展研究院刘国恩院长，北京大学科技开发部郑如清副部长、科学研究部刘譞哲副部长，北京大学电子学院冯梅萍书记、魏贤龙副院长、焦秉立教授等数十位领导嘉宾参加了本次活动。本次签约仪式由北京大学电子学院副院长魏贤龙主持。冯梅萍、闻库、刘譞哲、郑如清、王洋、焦秉立分别致辞。\n会议由冯梅萍书记致欢迎辞， 她介绍了北京大学电子学院自1958年建系开展研究以来，在先进通信技术领域的开创性研究成果，包括“TDM/CDMA VSAT卫星通信网”、“波分复用光纤通信系统”、“全光通信试实验网”、“广电接入ITU-T国际标准”等，并且承担和完成了多项卫星通信和无线通信领域的国家重点研发项目；长期以来，北京大学重视并积极推动校企联合和产学研的深度融合。冯书记衷心希望能更好地发挥北京大学电子学院学科的领先优势，以及时空道宇的企业研发创新优势，期望双方优势互补，共同努力，推动前沿技术研究与产业化的链接，为国家电子通信产业发展贡献力量。',
    img1:'北京大学电子学院冯梅萍书记致辞',
    des2:'闻库理事长在致辞中表示：如何实现将同频同时全双工通信技术（Co-frequency Co-time Full Duplex, CCFD，以下简称“全双工通信”）应用于无线通信领域，提高频谱利用率，一直以来是通信领域的关键技术难题，在6G时代，全双工技术将大有用武之地。焦秉立教授在全球最先提出并经过长达17年的潜心研究，实现从理论研究到实际应用的突破。期望联合实验室结合北京大学学术尖兵的优势，以及时空道宇的企业工程化实力，共同推动无线全双工通信在卫星通信领域实现创新性突破，期待双方的合作，尽快实现技术转化和落地，期待双方的强强联合可以给全世界带来好消息！',
    img2:'中国通信标准化协会闻库理事长致辞',
    des3:'刘譞哲教授代表梅宏院士向联合实验室的成立表示衷心祝贺，同时转达梅宏院士非常荣幸担任联合实验室技术委员会主任。世界已经进入大科学时代，研究的组织化程度越来越高，国家鼓励企业与科研机构开展联合研究。他表示，加强校企联合、校地联合和校医联合，是未来实现组织基础研究从0到1跨越的重要步骤。他非常感谢时空道宇对北京大学基础研究的大力支持，特别是对焦老师长期从事开创性工作的大力支持。数字经济时代，构建万物互联，天地一体的交互网络，是新的数字空间重要的基础设施。实现同频同时全双工卫星通信，不仅代表着卫星通信方式的更新换代，还将涉及到未来频谱资源的争夺。这项工作意义非常重大，既面向世界的科技前沿，也面向国家的重大需求。他希望联合实验室获得更多突破，在人才培养等领域做出更多贡献，实现高水平的科技自立自强，为教育强国、科技强国和人才强国做出更大的贡献。',
    img3:'北京大学科学研究部刘譞哲副部长致辞',
    des4:'郑如清致辞：开展校企合作，设立联合实验室，是北京大学将学术研究和产业需求相结合的一个重要的举措，也是进行有组织的高质量科研和成果转换的重要方式。先进通信技术已经成为现代社会的基石，对经济、科技、社会、社交和文化的各个方面都产生了深远的影响。同时，当今的社会、市场和国家都对通信技术提出了日益复杂和迫切的需求，通过联合实验室平台，将汇聚电子学院，还有软件与微电子学院等院系优秀的研究人员，以及时空道宇最前沿的技术工程资源，进行优势互补，推动通信领域的创新发展。联合实验室将不仅成为学术研究的殿堂，更是成为技术的引领者。双方通过共同努力积累中国自己的核心技术，并为全球6G星地融合核心技术贡献中国力量，造福人类社会。',
    img4:'北京大学科技开发部郑如清副部长致辞',
    des5:'王洋表示，北京大学一直致力于聚焦“高精尖缺”的前沿领域研究，在国内积极推动6G通信领域关键技术的研发探索。目前，6G领域的核心技术突破点包含全双工通信技术、AI与无线通信技术的融合、通感算一体化、频谱智能管理等。时空道宇与北京大学通过本次战略合作，将致力于攻克未来通信领域的核心技术——全双工通信技术。卫星网络是未来6G的重要组成部分，双方将共同研发全双工通信低轨卫星，推进该项技术在轨验证，同步推动行业标准制定，加速产业应用落地，引领全球通信领域的技术变革。',
    img5:'浙江时空道宇科技有限公司王洋CEO致辞',
    des6:'焦秉立教授作工作报告，他通俗易懂地为大家介绍了全双工通信在未来应用以及推动通信行业快速发展的价值：首先回顾历史原因，分析了高速无线通信占带宽、双向通信占用带宽的冗余性及CCFD在解决频率资源日益匮乏的作用。从本质上讲，CCFD是在同一个频率实现的双向通信方法，它将传统两个频率合并为一个，因此将频率资源节约一半。虽然，CCFD在技术上有很大挑战，但是，北大团队已完成了一系列技术突破。特别是如下两个技术环节：（1）低于热噪声的自干扰消除技术；（2）结合卫星仓体的极化天线技术。此外，北大具有CCFD原创性专利，并积累了多项相关专利。\n实际上，从去年起北大开始寻求在卫星上实现CCFD从0到1的突破，对时空道宇的卫星超级工厂及相关应用落地情况进行考察，开始正在与时空道宇合作推动相关技术的产业化应用落地。目前双方达成一致共同推进研究开发，攻克技术难点，为推进CCFD通信低轨卫星应用，相信CCFD卫星通信的实现将带来频谱重新规划，届时我国在国际上将具有更大的话语权。',
    img6:'北京大学电子学院教授焦秉立作现场报告',
    des7:'在与会人员共同见证下，联合实验室正式签约。',
    img7:'北京大学—时空道宇先进通信联合实验室签约仪式',
    des8:'随后进入会议讨论阶段，王洋进一步介绍了时空道宇，它作为国内创新型科技企业，在全球范围内，首次将卫星通信应用于新能源量产车，是目前国内唯一实现商业闭环的民营商业航天企业。旗下台州卫星超级工厂是中国首个深度融合航天制造和汽车制造能力的卫星量产工厂，开创了商业航天领域量产AIT服务新模式，可实现日产1颗卫星，助力星座快速组网。时空道宇通过与北京大学开展深度合作，推动中国5G+/6G领域核心技术研发及行业标准制定，加速卫星通信系统产业化进程，并积极推动6G核心通信技术在未来出行等领域的产业化应用落地。\n北京大学全球健康发展研究院刘国恩院长表示，他对全双工卫星通信技术在全球健康领域的应用寄予厚望。北大全健康研究院自成立以来，已从关注国内健康扩展到全球健康。他希望全双工卫星通信技术能与全球健康工作关联，实现更有效、更精准、更全面地为中国居民提供健康保障，包括救援保障和医疗服务资源的协调。进而，他提到如果能利用卫星技术照顾到一带一路沿线国家，将有助于中国国际化进程。刘院长强调，他愿意作为项目支持者，提供保障。他希望合作顺利、成功，为中国和全球健康命运共同体的目标实现做出贡献。他还补充道，中国的主要健康问题是脑血管等突发性疾病，时空道宇拥有车联网以及卫星通信领域的完整先进产业链及大规模成熟落地应用，可以在医疗紧急救治方面，大幅提高救援效率，将对全球健康事业做出巨大贡献。与会其他专家教授进行了热烈的讨论。',
    img8:'北京大学全球健康发展研究院刘国恩院长发言',
  },
  news3: {
    title:'普林斯顿大学文森特·珀尔教授访问北京大学并做学术演讲',
    des1:'2017年9月11日，应北京大学“大学堂”顶尖学者讲学计划邀请，普林斯顿大学工程与应用科学学院院长、美国科学院及工程学院院士文森特·珀尔（H. Vincent Poor）教授到访北京大学，接受北京大学名誉教授称号，并进行了为期两天的学术交流。珀尔教授在通信和信息论研究领域享有极高的学术威望，此次来到北京大学讲学，除了进行专题学术演讲外，珀尔教授还主持了北京大学-普林斯顿大学联合实验室举办的学术研讨会，与国内外相关领域的学者及部分北大教师和学生就先进通信理论与技术研究展开了深入讨论。本次活动由国际合作部与信息科学技术学院承办，光华教育基金会提供资助。',
    img1:'龚其煌副校长向文森特·珀尔教授颁发北京大学名誉教授证书',
    des2:'9月11日上午，北京大学在理科二号楼2129报告厅举行文森特·珀尔教授名誉教授授予仪式，龚其煌副校长代表学校对珀尔教授的到访表示热烈欢迎。仪式由北京大学信息科学技术学院焦秉立教授主持，焦秉立教授首先介绍了珀尔教授的主要学术成就，特别提到了珀尔教授为CDMA技术在移动通信系统中的成功应用做出了重要贡献。随后龚校长向珀尔教授颁发了北京大学名誉教授证书。授予仪式结束后，珀尔教授发表题为“智能电网：当能量遇到信息”的专题演讲。智能电网的物理层是传统的电力传输系统，而物理层之上的网络层则由传感器、通信网络及控制器构成。智能电网通过将信息科学领域的先进理论和技术应用于能源传输领域，旨在整合能量资源，提升电力网工作效率。珀尔教授综述了智能电网的发展概况和研究前沿，并以博弈论、信号处理和统计推理这三类信息科学技术为例，指示将信息科学学科的先进理论和技术应用到智能电网中，能够有效地提升电力传输系统的能源分配效率、安全性和可靠性，具有广阔的发展前景。',
    img2:'文森特·珀尔教授发表专题演讲“智能电网：当能量遇到信息”',
    des3:'9月12日上午，珀尔教授与北京大学焦秉立教授共同主持了北京大学-普林斯顿大学联合实验室举办的首届先进通信理论与技术研讨会。联合实验室邀请了清华大学、东南大学、北京邮电大学、美国南佛罗里达大学、台湾交通大学、香港中文大学的多位国内外顶级学者共襄探讨，部分北大教师和学生也参与了学习和讨论。此次研讨会着重关注无线通信技术前沿，珀尔教授指出当前提升通信质量的关键技术包含空间分集、频率分集和编码理论，而下一代通信技术将面临的挑战除了更高的通信容量和可靠性之外，能量效率也备受关注。针对这些挑战，珀尔教授提供了两条研究思路，一是研究物理层安全技术，保障通信可靠性；二是研究有限字长消息的传输理论，这对于第五代移动通信强调的短数据包业务具有实际意义。当天下午，珀尔教授和焦秉立教授还组织了北京大学-普林斯顿大学联合实验室顾问委员会讨论会，邀请包括邬贺铨院士、高文院士等顾问参加，研讨两校联合培养学生及联合实验室发展规划。',
    img3:'文森特·珀尔教授与焦秉立教授进行讨论',
    des4:'珀尔教授的科研领域主要为信息论、统计信号处理与随机分析及其在无线通信、社交网络和智能电网中的应用。他在无线通信领域提出过若干重要的研究方向：提出CDMA多用户检测研究方向，为CDMA在第二代和第三代移动通信系统的成功应用发挥了重要作用；提出无线物理层安全新概念，研究香农容量限为基础实现绝对安全通信提供了新方法。近几年，珀尔教授的研究不断向通信技术的应用领域拓展，并结合社会学中的人文特征。2010年，他在IEEE高影响力期刊Transactions on Information theory上发表题为Average message delivery time for small-world network in the continuum limit的文章；2013年，他在IEEE高影响力期刊Journal on Selected Area of Communications上发表题为From technological networks to social networks的文章，这在一定程度上反映出他研究领域之广泛，其研究成果对学术界和产业界产生了深远影响。',
    img4:'文森特·珀尔教授与出席先进通信理论与技术研讨会的专家学者合影留念',
    lastDes:'珀尔教授现为美国科学院院士、美国工程院院士、美国艺术与科学学院院士、英国皇家科学院院士和英国皇家工程院院士，同时担任8个国际知名学术机构的Society Fellow。珀尔教授曾编写过几十本通信领域专著，发表过数百篇学术论文，在通信和信息论研究领域享有较高的学术威望。此次珀尔教授的到访，将加速北京大学与普林斯顿大学联合实验室的建设和发展，促进世界一流人才与校内科研骨干的融合，开展高水平的学术交流，以推动科学研究、人才培养的全面创新和发展，增强创建世界一流大学的综合竞争力。',
  },
  //标准制定
  stad1: {
    time:"2017.03.22",
    title:'5G首次写入政府工作报告 标准制定中国话语权占比很大',
    des1:'',
    img1:'北京大学教授焦秉立（左）、中国通信学会副理事长张新生（右）',
    lastDes:'今年的政府工作报告提出，加快第五代移动通信（5G）等技术研发和转化，这是5G首次被写入政府工作报告。如何看待5G给中国通信行业带来的机遇与挑战?中国在制定5G标准上有多大话语权?近期，中国通信学会副理事长张新生、北京大学教授焦秉立接受了人民网记者的专访。',
  },
  stad1_question1: {
    question:'人民网记者：近几年国内通信企业强势壮大的原因是什么？', 
    answer1:'张新生：第一，中国在通信领域，特别是无线移动通信领域，通过近几年的努力，有几家企业已经逐渐成为跨国企业。在这些跨国公司的带动下，中国通信发展的速度和通信科技创新的产业化就比较快。国内通信行业的跨国公司，不管在国内有没有科技创新和基金，但是为了发展，企业一定会不停的投入大量的钱和精力来搞研发、搞创新。',
    answer2:'第二，通信产业已形成完整的产业链、产业生态。跨国企业全球配置资源最大的好处是，促使产业链和产业生态的形成。比如 5G、4G、3G，从芯片、终端、系统、天线、仪表，所有的配置都要布置项目，从中找到最短板来发展。',
    answer3:'第三，国家政策适合推动通信行业发展。同时，在科研创新的体制上，包括技术体制和大学体制，有一批人员专门从事这一行业。',
  },
  stad1_question2: {
    question:'人民网记者：中国在 5G 标准制定中有多大话语权？', 
    answer1:'焦秉立：中国在 5G 标准制定中话语权占比很大。国际标准制定是构造一个全球通信系统的必要环节。从过去发展看，任何一代新系统产生，它既包括新旧技术的更迭，又包括传统技术的继承。因此，众多公司在标准竞争上，实际基于各自新技术实力和既得利益的进行博弈。而标准会议中的话语权，主要由公司的影响力决定，它除了上面说的两点，所占市场额度、范围也在很大程度具有影响。',
    answer2:'在移动通信领域，中国企业历来占据市场优势（例如：中国移动和华为等），随着国家重视和大量投入，中国的企业通过研发，在技术上得到了快速发展，已经达到国际相同水平。因此话语权也与日俱增。目前，在某些方面与国际大公司基本持平。',
  },
  stad1_question3: {
    question:'人民网记者：目前 5G 发展现状如何？', 
    answer1:'张新生：2017 年是 “5G 发展承上启下的关键年、重要年”。互联网企业和垂直行业蕴含着对 5G 的巨大需求。互联网企业希望通过 5G 来实现根据业务需求，自动提供、维护、终结网络服务，减少成本。而垂直行业则希望能利用运营企业的网络平台获得网络的专有服务。',
    answer2:'4G 满足了大连接，5G 的目标不仅要满足传统的人与人通信的需要，还要支持海量的人与物、物与物之间的连接。随着移动互联网发展的日趋平稳，物联网成为了移动通信发展的下一个金矿，物联网也将是 5G 发展的最重要的驱动力，因此 5G 和物联网注定将紧紧联系在一起。',
    answer3:"中国在 5G 发展过程中，经历了领跑 - 引领 - 领跑 - 同步的阶段。全世界的政府都希望自己国家的企业处于领导地位。中国亦是如此，希望华为、中兴等企业在 5G 上能够实现领跑。现在行业内认为领跑的两家公司是华为和高通。",
    answer4:"高通和市场研究机构 HIS MARKIT 日前编制发布的《5G 经济：5G 技术将如何影响全球》报告显示，到 2035 年 5G 将在全球创造 12.3 万亿美元经济产出，全球 5G 价值链将创造 3.5 万亿美元产出，同时创造 2200 万个工作岗位。利益在前面，谁不往前赶，就赶不上班车。所以，最近一年 5G 的发展比以前想象的速度加快，竞争愈加激烈。"
  },
  stad1_question4: {
    question:'人民网记者：对于未来 5G 在中国发展有何建议？', 
    answer1:'张新生：第一，随着 5G 技术的发展，需求量的增加，速率带宽不断提高，对频率的使用提出更高的要求。对于高频段的需求越来越大。由于以前频谱的资源分配造成现在需要相对关注频率、高频段。实现 5G 发展，可能还要用其他技术，目前在频率、高频段这块就是一个短板。',
    answer2:'第二，将来整个 5G 发展和垂直行业的发展，如何能结合得更好。2020 年 5G 要商用，在商用过程中，各个企业希望利益最大化。推动中国经济发展，5G 是一个很好的点，希望在 5G 发展过程中，能真正体现中国 5G 发展是产业链的发展，是生态的发展。如果不是这样，5G 相对还不算成功。',
    answer3:"希望政府给些政策，从社会团体角度让跨行业部门尽快结合起来，让应用的行业部门和通信部门坐在一起，共同商讨 5G 发展要做的大量工作。因为目前优势在应用上，只有把各行各业的应用和 5G 结合好，未来 5G 才会更好的发展。如美国，在政府的推动下，由运营商、制造商和跨行业建成所谓的联盟。美国 5G 联盟，就是由 24 家单位组成的。",
    answer4:"焦秉立：创新是中国达到国际先进，进而引领通信发展之根本。而中国需要解决的一个问题就是：知识产权保护。从现代商业运作上看，知识产权不仅是一种个人、公司荣誉、广告，更重要的是一种实际存在的具有商业价值的产物。",
    answer5:"保护和尊重知识产权，将维护创新动力、实现创新价值、铺平企业健康的道路。在这方面，除了需要严格法律法规外，还需要转变概念。如果知识产权保护问题不能得到很好的解决，全民创新就有可能成为全民抄袭。未来 5G 在中国的发展过程中，创新驱动是灵魂，希望政府出台相应的政策法律，在知识产权方面严格化。"
  },
  stad2: {
    time:"2016.03.31",
    title:'信息科学技术学院焦秉立课题组应邀在NGMN论坛作同频同时全双工技术系统级展示',
    des1:'日前，由下一代移动网络（next generation mobile networks,NGMN）联盟等主办的NGMN论坛暨第五代移动通信网络（fifth-generation,5G）峰会在台北举行。\n由北京大学信息科学技术学院焦秉立教授课题组与清华大学、台湾新竹交通大学共同组成的科研团队作为在同频同时全双工为主题上唯一受邀团队参会，并作了口头报告和系统级展示。马猛副教授在20m×20m的环境中，成功地向通信领域国际专家、业界同行和媒体演示了自主开发的同频同时全双工组网系统，引起大家浓厚兴趣，对消除该项技术组网问题上的同行质疑起到积极作用。\n同频同时全双工是北京大学课题组于2006年提出的一种双向通信技术，被认为是支撑未来5G高效率的两大关键技术之一。历经9年多的理论研究和实际开发，作为团队核心的北大课题组取得了一系列标志性进展：2012年，课题组实现了室内双向通信演示系统；2014年，NGMN联盟首席执行官Peter Meissner博士参观该系统后，在NGMN官方网站上首次提出“同频同时全双工技术是5G候选技术之一”；同年12月，课题组将通信距离从50m提高到500m，意味着该技术在点对点通信上取得重大突破，技术指标达到微蜂窝移动通信系统的实际应用要求。',
    img1:'北京大学团队与NGMN联盟首席执行官Peter博士合影',
    lastDes:'课题组的同频同时全双工技术始终处于国际领先地位，目前已联合企业进入芯片制造阶段。其研究得到了国家自然科学基金、国家科技重大专项、科技部港澳台科技合作专项的支持。',
  },
  stad3: {
    time:"2024.10.22",
    title:'德国Fraunhofer HHI Thomas Haustein教授访问北京大学焦秉立教授实验室',
    des1:'2024年10月21日，德国Fraunhofer HHI Thomas Haustein教授率团队访问北京大学焦秉立教授实验室，双方围绕通信技术标准化与前沿研究展开交流。',
    img1:'座谈会现场',
    des2:'Haustein教授分享了HHI在5G/6G物理层算法、多天线系统及动态资源调度领域的研究经验，重点探讨了欧洲标准化进程中的技术挑战。焦秉立实验室展示了团队在全双工通信干扰消除、低轨卫星组网及医疗物联网领域的创新成果，并现场演示了相关实验平台的技术验证。\n双方参观了实验室的卫星通信与医疗物联网研究设施，就星地协同网络优化、医疗传感设备能效管理等技术问题交换意见，并探索了学术合作与学生交流的潜在方向。此次访问为中德双方在无线通信前沿领域的合作提供了新契机。',
    img2:'与会嘉宾合影',
  },
  lecturesinfo: "讲座公告",
  //讲座公告
  lectures1:"2025年6月16日",
  lectures2:"地点：北京大学",
  lectures3:"具体地点：另行通知",

  lectures2_1:"2025年6月19日",
  lectures2_2:"地点：北京大学",
  lectures2_3:"具体地点：北京大学英杰交流中心星光厅",

  //讲座公告详情
  info1:"6月16日VTS讲座--潜在扩散模型驱动的低延迟语义通信",
  info2:"在本报告中，报告人将介绍她最新研究成果——基于深度学习的语义通信（SemCom）系统鲁棒性与适应性的增强方法，该系统对提升下一代无线网络效率至关重要。传统语义通信技术常受限于无线信道波动、源数据异常分布及泛化能力薄弱等挑战。为此，报告人提出了一种由潜在扩散模型驱动的新型语义通信框架，其核心包含三大创新：通过语义对抗扰动训练实现的异常鲁棒编码器、支持单样本学习并提升分布外数据适应能力的轻量化单层潜在适配器，以及可在噪声环境中实现低延迟高质量去噪的端到端一致性蒸馏（EECD）方法。这些技术协同作用，显著提升了语义通信系统的抗逆能力、环境适应性及语义保真度。",
  info3:"时间：2025年6月16日 9:00-12:00",
  info4:"地点：北京大学",
  info5:"具体时间，讲座地点另行通知",
  info6:"报告人：",
  info7:"Ping Wang, 加拿大约克大学教授，IEEE Fellow, Distinguished Lecturer of the IEEE Vehicular Technology Society，她的研究兴趣在无线通信与网络，物联网，机器学习，云计算资源管理，智能电网能源管理。",

  info2_1:"同频同时全双工卫星通信技术科技成果鉴定会",
  info2_2:"时间：2025年6月19日（周四）9:30-12:00",
  info2_3:"地点：北京大学北京大学英杰交流中心星光厅",
  info2_4:"主办单位：中国通信学会",
  info2_5:"成果完成单位：北京大学、浙江时空道宇科技有限公司",
  info2_6:"讲座内容：",
  info2_7:"本次科技成果鉴定会将围绕“同频同时全双工卫星通信技术”展开，重点介绍该技术在地面20KM模拟测试中的突破性进展及其在低轨卫星通信、6G等领域的应用前景。会议将包括项目汇报、专家质询、技术讨论等环节，并由鉴定委员会宣读最终鉴定意见。",
  info2_8:"参会人员:",
  info2_9:"鉴定委员会主任委员：陆建华院士（清华大学）",

  //科研进展
  kyjz1:"研究方向：",
  kyjz2:"无线通信理论与卫星通信系统",
  kyjz3:"研究编码与信息论，并于2006年率先提出“同频同时全双工（CCFD）通信技术”，2020年获得中国通信学会授予的技术发明一等。目前研究6G通信和实现CCFD卫星系统。",
  kyjz4:"医疗物联网",
  kyjz5:"长期从事5G与智慧医疗交叉领域的前沿研究，目前正在研究开发远程生命体征检测、医疗监护信息及数据智能分析和应用。",
  kyjz6:"专著出版",
  kyjz7:"《5G同频同时全双工技术》",
  kyjz8:"《未来移动通信论坛 5G关键技术系列》从同频同时全双工技术的产生背景和研究现状出发， 阐述了同频同时全双工技术的基本概念，描述了全双工通信系统的基本结构和几种典型通信系统的容量，并重点分析了同频同时全双工的自干扰问题，以及从全双工节点和全双工系统等层面，详细介绍了自干扰消除和自干扰抑制技术。 本书还介绍了全双工通信系统中的一些相关技术，包括全双工与MIMO结合技术、全双工功率控制技术、全双工多用户检测技术、全双工系统的资源管理和频谱规划策略以及全双工蜂窝系统中继转发技术。 在此基础上，重点介绍了全双工组网和全双工安全通信设计方案。 最后，还探讨了同频同时全双工D2D系统和无线局域网等新应用场景，展望了该技术在无线安全通信和认知无线电等领域中的应用。",
  // kyjz9:"《医疗物联网 - 网络框架与技术应用》",
  kyjz9:"《商业航天工程导论》",
  kyjz10:"本书是获得2020年度国家出版基金项目《面向远程医疗的移动物联网技术》的第二册。 本项目是在2012年国家科技重大专项项目（课题）“面向远程医疗和社区医疗信息化的无线物联网技术总体研究”成果基础上，结合最近三年相关研究进展（例如：人工智能在医疗物联网中的作用和应用，医学信息学在IT中数据、信息和知识等多方面的内容）撰写而成。该项目共分为两册：本书为第二册《医疗物联网：关键技术及其最新进展》主要讲述了医疗物联网网络关键技术和解决方案。全书共六章，第一章医疗物联网技术内含；第二章承载典型医疗健康业务及典型应用场景及其物联网架构；第三章 数字医疗技术体系架构；第四章 医疗网虚拟化研究；第五章 医疗健康信息学 ；第六章 未来研究之开发重点。",
  kyjz11:"《医疗物联网 - 概念、需求与发展进程》",
  kyjz12:"《医疗物联网：概念、需求与发展进程》是获得2020年度国家出版基金项目《面向远程医疗的移动物联网技术》的册。",
  kyjz13:"本项目是在2012年国家科技重大专项项目（课题）“面向远程医疗和社区医疗信息化的无线物联网技术总体研究”成果基础上，结合近三年相关研究进展（例如：人工智能在医疗物联网中的作用和应用，医学信息学在IT中数据、信息和知识等多方面的内容）撰写而成。该项目共分为两册：《医疗物联网：概念、需求与发展进程》为册《医疗物联网：概念、技术及其产业化发展》主要讲述了移动物联网在医疗体系中的建构与应用，讨论远程医疗物联网的战略、管理和产业推进策略。《医疗物联网：概念、需求与发展进程》共八章，章医疗物联网的概念及其发展现状；第二章我国发展医疗物联网的实际需求；第三章我国医疗物联网的作用和发展目标；第四章医疗物联网的技术概述；第五章移动医疗物联网；第六章医疗物联网知识产权分析；第七章我国医疗物联网的应用场景及产业发展的PEST分析；第八章我国医疗物联网产业化推进策略。",
  kyjz14:"《5G与智慧医疗》",
  kyjz15:"本书从5G改变生活说起，在介绍5G的基本概念和关键技术的基础上，首先讨论医疗信息化发展的现状，对智慧医疗的基本概念、组成和应用进行介绍，然后，本书阐述智慧医疗系统的体系架构和关键技术，特别是与5G相关的核心技术，并对智慧医疗在慢性病管理、智能养老、移动智能诊断服务、突发救治、智慧医院、精准医疗和医疗教育等主要应用场景下的架构和技术进行分析与总结，最后，本书对未来6G通信系统与智慧医疗深度结合的未来发展进行畅想。本书重点关注5G技术、智慧医疗技术及5G与智慧医疗相结合的关键应用场景，希望能给国内智慧医疗应用领域的从业者、研究者带来一定的启发。 本书适合医院信息化管理人员、高校智慧医疗研究开发人员和关注新一代信息技术，特别是新一代通信系统（5G/6G）技术在医疗健康领域开展创新应用实践的读者阅读和参考。",
  kyjz16:"《同频同时全双工关键技术与系统实现》",
  kyjz17:"同频同时全双工无线通信设备使用相同的时间、相同的频率，同时发射和接收无线信号，使得通信的频谱效率提高了一倍，本书从四个方面做了重点论述。其一，将空域调制方法融入同频同时全双工，形成空域调制全双工的系统和理论；其二，提出广义空域调制全双工概念，讨论组网中自干扰和互干扰问题、网络局部优化和全局优化平衡问题；(3)提出同频同时全双工与物理层安全结合的构想，研究全双工和速率与安全容量的关系；(4)研究计算机云平台与同频同时双全工结合的组网系统，为该技术未来应用和组网提供理论依据和解决方案，并最终搭建硬件平台。本书采用实验测试方法验证理论结果并分析应用前景。",
  kyjz18:"论文发表",
  kyjz19:"专利成果",
  kyjz20:"焦秉立，丁景泽，林立峰，一种基于全双工卫星的中继通信方法，专利号ZL202410621496.8，2024年5月20日",
  kyjz21:"段晓辉，马青变，谢宇飞，郑康，焦秉立，向一帆，李浩崴，吴泷彬，林立峰，一种医院院内无线报警快速响应方法及系统，专利号ZL202410517061.9，2024年4月28日",
  kyjz22:"焦秉立，周子健，林立峰，一种同频同时全双工自干扰残余功率检测装置，专利号ZL202310938202.X，2023年7月28日",
  kyjz23:"焦秉立，周子健，林立峰，一种基于耦合器合路的全双工射频消干扰装置，专利号ZL202310835778.3，2023年7月10日",
  kyjz24:"焦秉立，丁景泽，林立峰，基于择多判决的数据加解密方法，专利号ZL202310679815.6，2023年6月9日",
  kyjz25:"刘三军，李超，焦秉立，杨瑞，一种法罗滤波器系数优化方法 ，专利号ZL202310522636.1，2023年5月5日",
  kyjz26:"焦秉立，李文瑶，段晓辉，一种提高频谱效率的数据包封装方法，专利号ZL202211420463.4，2022年11月11日",
  kyjz27:"焦秉立，王晨博，林立峰，一种适用于全双工卫星通信的星载装置，专利号ZL202211391930.5，2022年11月8日",
  kyjz28:"焦秉立，周子健，林立峰，一种消除Nyquist滤波器符号间串扰的方法 ，专利号ZL202211391447.7，2022年11月8日",
  kyjz29:"焦秉立，郑东升，一种异步全双工数字域自干扰信道的估计方法，专利号ZL202211382979.4，2022年11月7日",
  kyjz30:"焦秉立，周子健，一种全双工射频自干扰的消除方法，专利号ZL202211369521.5，2022年11月3日",
  kyjz31:"焦秉立，李文瑶，一种全双工卫星通信自干扰的抑制方法，专利号ZL202211342869.5，2022年10月31日",
  kyjz32:"焦秉立，郑东升，一种基于天线位置调节的全双工自干扰消除方法，专利号ZL202210679418.4，2022年6月16日",
  kyjz33:"焦秉立，王晨博，一种同轴电缆结构及利用该结构实现低温情形同轴电缆衰减补偿方法，专利号ZL202210672205.9，2022年6月15日",
  kyjz34:"刘三军，吴民民，焦秉立，杨瑞，多用户有线保密通信系统及方法，专利号ZL202210087221.1，2022年1月25日",
  kyjz35:"黄双林，焦秉立，谭琼应，刘三军，基于数据包索引比特动态重组算法的数据包重组通信方法，专利号ZL202110910340.8，2021年8月9日",
  kyjz36:"林立峰，周子健，王晨博，焦秉立，尿湿监测仪，专利号ZL202130274852.0，2021年5月10日",
  kyjz37:"焦秉立，王晨博，朱舸，董亚洲，林立峰，一种数字域正交双极化天线极化方向控制方法，专利号ZL202011293063.2，2020年11月18日",
  kyjz38:"研究方向一：",
  kyjz39:"研究方向二：",
  //全双工通信
  sgtx1:"4.6km高空热气球测试_1",
  sgtx2:"6.2km地面测试_3",
  sgtx3:"20km地面测试_1",
  sgtx4:"20km地面测试_5",
  sgtx5:"500m固定翼无人机测试_3",
  sgtx6:"4.6km高空热气球测试_2",
  sgtx7:"6.2km地面测试_4",
  sgtx8:"20km地面测试_2",
  sgtx9:"4.6km高空热气球测试_2",
  sgtx10:"100m低空四旋翼无人机测试_1",
  sgtx11:"500m固定翼无人机测试_4",
  sgtx12:"6.2km地面测试_1",
  sgtx13:"6.2km地面测试_5",
  sgtx14:"20km地面测试_3",
  sgtx15:"20km地面测试_5",
  sgtx16:"500m固定翼无人机测试_5",
  sgtx17:"6.2km地面测试_2",
  sgtx18:"6.2km地面测试_6",
  sgtx19:"20km地面测试_4",
  sgtx20:"500m固定翼无人机测试_2",
  sgtx21:"西安自干扰测试_1",
  sgtx22:"西安自干扰测试_2",
  //标准制定
  bzzd1:"5G首次写入政府工作报告标准制定中国话语权占比很大",
  bzzd2:"2024年10月21日，德国Fraunhofer HHI Thomas Haustein教授率团队访问北京大学焦秉立教授实验室，双方围绕通信技术标准化与前沿研究展开交流。",
  bzzd3:"信息科学技术学院焦秉立课题组应邀在NGMN论坛作同频同时全双工技术系统级展示",
  bzzd4:"德国Fraunhofer HHI Thomas Haustein教授访问北京大学焦秉立教授实验室",
  // 全双工通信
  fullDuplex:{
    title1:"一、同频同时全双工介绍",
    p1:"电磁波作为无线通信信息传输的核心载体，其可用频谱资源经过划分后形成有限的独立频段。随着无线通信技术的迅猛发展，频谱资源日益紧张的局面已成为制约行业发展的瓶颈。",
    p2:"由于无法通过拓展物理边界来增加频率资源，提升频谱利用效率便成为解决这一难题的根本途径。同频同时全双工技术（Co-frequency co-time full duplex，CCFD）通过将传统频分双工（FDD）系统的发射与接收频段合二为一（或将时分双工（TDD）系统的上下行时隙合并），理论上可使频谱效率实现倍增。这一技术突破可以形象地比作将原本分隔的双向高速公路合并为同一车道，实现车辆的双向并行通行：",
    title2:"二、CCFD技术难点",
    p3:"CCFD技术的关键难点在于其将发射信号与接收信号配置在完全相同的频点上，导致发射机信号对接收机产生严重的自干扰问题（Self-Interference, SI）。由于发射信号功率通常比接收信号功率高出数十甚至上百dB，如何有效消除这一巨大功率差带来的自干扰，成为CCFD技术实现的核心挑战。下图展示了两个CCFD节点间的通信场景及其面临的自干扰问题。",
    title3:"三、卫星CCFD平台设计",
    title3_1:"1.天线隔离设计",
    p4:"为有效抑制自干扰，采用收发天线物理分离方案是CCFD系统的关键设计之一。图（a）（b）分别表示了天线设计和实际测试照片：",
    title3_2:"2.椭圆正交极化消除方法",
    title3_2_1:"(A) 椭圆极化天线阵列设计",
    p5:"采用64单元阵列天线架构，其中32个辐射单元发射水平极化（H波），另外32个单元发射垂直极化（V波），通过正交极化实现收发隔离。天线阵列实物图如图2（a）所示，对应的发射信号特征如图2（b）所示：",
    p6:"当发射天线发射左旋椭圆自干扰电磁波时，接收天线精细调制为一个正交右旋波状态时，则可以完全消除自干扰。 ",
    title3_3:"3.低于底噪的消除方法",
    p7:"传统方法遇到的困难是当自干扰功率接近热噪声功率时，消除器无法清晰识别自干扰，从而无法准确消除。我们提出了一种突破性的低于底噪的自干扰消除技术，通过创新性地采用128符号长度的自相关处理方法，成功解决了传统方案在干扰功率接近热噪声时失效的关键难题。该技术具有两大核心优势：首先，在干扰功率低于热噪声10dB的条件下仍能保持10dB以上的相关增益；其次，结合椭圆极化正交技术，在射频域实现了高达120dB的干扰消除深度。如图所示（标注\"Signal\"为自干扰信号），这一突破性进展使得全双工通信系统首次具备了在噪声功率以下继续消除自干扰的能力，为提升频谱效率提供了重要的技术支撑。",
    title4:"四、卫星CCFD平台设备",
    p8:"下图展示了我们研制成功的CCFD工程样机实物，该设备采用紧凑型设计（25cm×25cm×8cm），整机重量仅3.5kg，具有优异的空间适应性。目前已完成全部环境可靠性测试（包括热真空试验和力学振动试验），各项指标均满足星载要求。本设备由北京大学-时空道宇联合实验室牵头研制，计划于2025年8月搭载卫星发射入轨。",
    title5:"五、“北大时空”卫星系统",
    img_des1:"图1（a）北大时空星设计",
    img_des2:"图2（b)微波暗室实验自干扰隔度测试",
    img_des3:"图2（a）收发椭圆阵列照片",
    img_des4:"图2 (b) 椭圆左旋发射电磁波示意图",
  },
  //
  medical_page: {
    title1:"一、全双工通信技术在医疗物联网中的创新应用",
    p1:"通信技术作为医疗物联网的核心支撑，正处于5G向6G演进的关键跃升期。在这一重大技术转型窗口，我国亟需在低轨卫星通信等前沿领域实现关键技术突破，以掌握全球产业发展的主导权。同频同时全双工（CCFD）技术通过实现频谱效率的倍增式提升，为低轨卫星通信带来了革命性的创新突破，这一技术突破对数据密集型的医疗物联网应用具有特殊战略价值。该技术的深度研发与产业化应用，不仅能够有力支撑国家\"网络强国\"和\"健康中国\"的战略部署，更能为生命科学领域的创新发展构建新一代数字基础设施，推动医疗健康产业生态的转型升级。这一技术路径的确立，将使我国在全球医疗物联网技术竞争中占据制高点，为构建人类卫生健康共同体贡献中国智慧和中国方案。",
    title2:"二、智慧医疗应用场景",
    part2List:[
      {
        title: "远程医疗",
        content: "基于5G网络切片和CCFD技术，实现4K/8K超高清远程会诊、实时手术指导和三维医学影像传输。通过医疗物联网平台，打通城乡医疗资源，使偏远地区患者可获得三甲医院专家服务，典型应用包括远程诊断、多学科会诊和术后随访，有效解决医疗资源分布不均问题。"
      },
      {
        title: "院内应用",
        content: "采用RFID和室内定位技术，实现医护人员、医疗设备和患者全流程智能管理。包括智能药柜自动盘点、输液监控、患者腕带定位和医疗设备追踪，显著提升院内运营效率。通过5G医疗专网，支持移动查房、电子病历实时调阅和AI辅助诊断，打造数字化智慧医院。"
      },
      {
        title: "院前急救",
        content: "利用5G网络uRLLC特性，实现救护车与医院间的生命体征（心电、血氧等）实时传输和视频会诊。通过车载CT等设备，完利用5G网络uRLLC特性，实现救护车与医院间的生命体征（心电、血氧等）实时传输和视频会诊。通过车载CT等设备，完成\"上车即入院\"的急救新模式，为卒中、心梗等急症争取黄金抢救时间。医疗物联网系统自动同步患者信息，实现院前院内无缝衔接。"
      },
      {
        title: "健康管理",
        content: "依托可穿戴设备和家庭传感网络，持续监测慢病患者生理参数。通过5G mMTC连接海量设备，构建个人健康数据中心，结合AI分析提供个性化健康建议。典型应用包括居家养老监护、糖尿病管理和孕产妇随访，实现从治疗向预防的健康模式转变。"
      }
    ],
    title3:"三、专利与技术突破",
    part3List: [
      {
          "title": "1.同频同时全双工（CCFD）技术创新",
          "content": "团队研发的新型自干扰消除方案采用混合域干扰消除技术（天线隔离+模拟消除+数字消除），将频谱效率提升至传统系统的1.8倍，特别适用于医疗大数据传输场景。针对医疗应用的特殊需求，开发了基于业务优先级的动态资源调度算法，实现关键业务（如远程手术）的毫秒级低时延保障。该技术已成功应用于多家医院的远程医疗系统。"
      },
      {
          "title": "2.医疗物联网体系架构创新",
          "content": "团队创新性地将RFID技术与5G网络深度融合，开发了医疗资产智能管理系统，实现医疗设备、药品的高精度实时定位。在四层架构中，感知层整合了多模传感器（包括医疗级可穿戴设备），网络层采用5G切片技术为不同医疗业务提供差异化QOS保障，平台层构建医疗大数据分析引擎，应用层开发了包括智慧病房、移动护理等创新应用。"
      },
      {
          "title": "3.5G智慧医疗应用创新",
          "content": "在远程手术方面，团队开发了基于5G+CCFD的超低时延传输系统，结合增强现实（AR）技术，实现手术画面的实时三维重建与标注，为远程手术指导提供精准支持。移动急救方案整合了车载生命体征监测设备（如便携式CT）与医院信息系统，通过边缘计算实现急救数据的实时处理，大幅缩短急救响应时间。在可穿戴设备方面，优化了基于NB - IOT的传输协议，显著降低了设备功耗，支持医疗级精度的持续生命体征监测，为慢病管理和健康监护提供了可靠的技术保障。"
      }
    ],
    title4:"四、代表性贡献",
    p4:"本团队在医疗物联网领域持续开展创新研究，主要贡献包括：",
    part4List:[
      {
        "title": "1.关键技术研究",
        "content": "焦秉立教授2012 - 2015年主持国家科技重大专项“新一代宽带无线移动通信网”中“无线医疗物联网总体规划”课题，主持开展医疗物联网体系架构研究，团队提出了符合我国医疗信息化需求的无线物联网体系架构，完成了远程医疗和社区医疗场景下的技术方案设计。"
      },
      {
        "title": "2.系统研发与应用",
        "content": "研发的医疗物联网通信系统在多家医疗机构成功部署，支持远程会诊、设备管理等核心业务。开发的智能医疗设备管理系统有效提升了医院运营效率"
      },
      {
        "title": "3.标准化推进",
        "content": "参与制定医疗健康物联网相关技术规范，研究成果被纳入行业指导文件，推动医疗物联网规范化发展。"
      },
      {
        "title": "4.技术推广",
        "content": "研发成果在公共卫生服务中得到实际应用，为提升医疗服务可及性提供技术支撑。与产业界合作促进技术成果转化，推动医疗物联网生态建设。"
      }
    ]
  }
};
